/**
 * Author: ziven27
 * Date: 2020-08-13
 * Desc: 图标
 */

import React from "react";
import type { ComponentProps, IconSvgProps } from "./interfaces";
import styles from "./styles.module.scss";

/**
 * 图标
 * @param {string} className
 * @param {string} isSelfColor - 是否使用图标自身颜色
 * @param {number|string} size
 * @param {Component} Svg
 * @param otherProps
 * @returns {JSX.Element}
 * @constructor
 */
const Icon = ({
  className = "",
  isSelfColor = false,
  size = 16,
  Svg,
  ...otherProps
}: ComponentProps) => {
  // 共用的属性
  const commonProps = {
    width: size,
    height: size,
    className: `${styles.icon} dib vam ${className} ${
      isSelfColor ? "" : "_no_color"
    } `,
    ...otherProps,
  };

  // webnovel-icons 里面的方式
  // webnovel-icons 现在返回的是一个 object 参考底部的 Proptypes 定义
  if ((Svg as IconSvgProps)?.dangerouslySetInnerHTML) {
    return <svg {...(Svg as IconSvgProps)} {...commonProps} />;
  }

  // 这里是直接引用 svg 或者 传入对象的方式
  // ⚠️ 这里 svg 的大小写
  if (typeof Svg === "function") {
    return <Svg {...commonProps} />;
  }
  return null;
};

export default Icon;
